"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUserEventPayload = exports.UserEventPayloadSchema = void 0;
const zod_1 = require("zod");
const types_1 = require("./types");
/**
 * Client-side mirror of the backend `CreateEventDto` constraints.
 *
 * Validating locally means a malformed payload is DROPPED on the client instead
 * of generating a 400 plus a Datadog error entry on the backend. The bounds
 * below are the backend's, verbatim:
 *   - userId  : @IsInt + @Min(1)
 *   - device  : @IsNotEmpty + @MaxLength(255)
 *   - browser : @IsNotEmpty + @MaxLength(255)
 *   - platform / eventType: @IsEnum
 */
exports.UserEventPayloadSchema = zod_1.z.object({
    userId: zod_1.z.number().int().positive(),
    device: zod_1.z.string().min(1).max(255),
    browser: zod_1.z.string().min(1).max(255),
    platform: zod_1.z.enum(types_1.EVENT_PLATFORMS),
    eventType: zod_1.z.enum(types_1.USER_EVENT_TYPES),
});
/**
 * Parse without throwing. Returns the validated payload or null.
 */
const parseUserEventPayload = (input) => {
    const result = exports.UserEventPayloadSchema.safeParse(input);
    return result.success ? result.data : null;
};
exports.parseUserEventPayload = parseUserEventPayload;
